export default {
    PtSelectLanguage: {
        language: '语言',
    },
};
